import classNames from 'classnames';
import { intersection } from 'ramda';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Category } from 'vms-base';
import SelectFieldEditor from '../select-field-editor/SelectFieldEditor.jsx';
import { POI_FIELDS } from '../constants';

import s from './InfoEditor.module.scss';

const makeCategoryOptions = categories => Category.asDropdownOptions(categories);

export default class DisplayEditor extends Component {
    static propTypes = {
        categories: PropTypes.arrayOf(PropTypes.object),
        category: PropTypes.object,
        changedFields: PropTypes.arrayOf(PropTypes.string),
        disabled: PropTypes.bool,
        iconOptions: PropTypes.arrayOf(PropTypes.object),
        isV5: PropTypes.bool,
        onUpdatePoiFields: PropTypes.func,
        v4Icon: PropTypes.string,
    };

    static defaultProps = {
        categories: [],
        category: {},
        changedFields: [],
        disabled: false,
        iconOptions: [],
        isV5: false,
        onUpdatePoiFields: () => {},
        v4Icon: '',
    };

    selectCategory = selectedCategory => {
        const { isV5, onUpdatePoiFields, categories } = this.props;
        let updates = { category: selectedCategory };

        const category = Category.fromCategoryList(selectedCategory, categories);
        updates = isV5 ? Category.fromV5CategoryToIcon(updates) : Category.fromV4CategoryToIcon(category, updates);

        onUpdatePoiFields(updates);
    };

    selectIcon = value => {
        const iconId = Category.getIconFromV4Value(value);
        this.props.onUpdatePoiFields({ icon: iconId });
    };

    renderBanner = (title, fields = [], subtitle = '') => {
        const { changedFields } = this.props;
        const isDirty = intersection(fields, changedFields).length > 0;
        const bannerClasses = classNames(s.banner, { [s.dirty]: isDirty });
        const subBanner = subtitle ? <div className={s.subBanner}>{subtitle}</div> : null;
        return (
            <div className={s.bannerWrapper}>
                <div className={bannerClasses}>{title}</div>
                {subBanner}
            </div>
        );
    };

    render = () => {
        const { categories = [], category = { canonicalName: '' }, isV5, v4Icon, iconOptions = [], disabled } = this.props;
        const categoryOptions = makeCategoryOptions(categories);
        const selectedIcon = v4Icon && !isV5 ? Category.fromV4IconToValue(v4Icon) : category.canonicalName;
        return (
            <div className={classNames(s.infoEditor)}>
                {this.renderBanner('DISPLAY OPTIONS', [POI_FIELDS.CATEGORY, POI_FIELDS.ICON])}
                <div className={s.controlsGrid}>
                    <SelectFieldEditor label="Category" onValueSelected={this.selectCategory} options={categoryOptions} selectedValue={category.canonicalName} disabled={disabled} />
                    <SelectFieldEditor
                        categoryIcons
                        disabled={isV5 || iconOptions.length === 0 || disabled}
                        label="Category Icon"
                        onValueSelected={this.selectIcon}
                        options={iconOptions}
                        selectedValue={selectedIcon}
                    />
                </div>
            </div>
        );
    };
}
